export default __webpack_public_path__ + "static/media/Punto_Benvenuto_SPA_Def.670575b6.aac";